import useSWR from 'swr';

import { IDetailResponse, IPaginatedResponse } from 'utils/types';

import { fetcher } from './utils';

export interface ILabel {
  id: number;
  title: string;
  description: string;
  usage: string[];
  parent_id: null | number;
  count: number;
  children: ILabel[];
  usage_matched: boolean;
  updated_at: string;
}

export const useLabelList = (params?: object) => {
  const url = `/v4/dash/labels`;

  const { data, isLoading, mutate, error, isValidating } = useSWR<IPaginatedResponse<ILabel>>(
    { url, params },
    fetcher
  );

  return { data: data?.data, meta: data?.meta, isLoading, mutate, error, isValidating };
};

export const useLabel = (id?: number | null) => {
  const { data, isLoading, error, mutate, isValidating } = useSWR<IDetailResponse<ILabel>>(
    id ? `/v4/dash/labels/${id}` : null,
    fetcher
  );

  return { data: data?.data, isLoading, error, mutate, isValidating };
};
